/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.7.13",
    versionName: "0.4.0-nightly.2026.7.13",
    versionChannel: "nightly",
    buildDate: "2026-07-13T00:27:33.008Z",
    commitHash: "2280440a58d75ba1d0901e304c8fe92860955e26",
};
